import EmblaCarousel from "embla-carousel";
import Fade from "embla-carousel-fade";
import lozad from "lozad";

// NOTE: 呼び出し側は、`arrows: false`にする必要あり
const initializeEmblaModal = (element, scrollToIndex) => {
  const container = element.querySelector(".c-embla__container");
  if (!container) return;

  const emblaOptions = { loop: true, duration: 20 };
  const emblaApi = EmblaCarousel(container, emblaOptions, [Fade()]);

  emblaApi.scrollTo(scrollToIndex);

  // NOTE: モーダル内のすべてのスライド画像を一括でLazyloadを発火させる
  const lazyElements = element.querySelectorAll(".js-lazy:not([data-loaded])");
  if (lazyElements.length > 0) {
    const observer = lozad(lazyElements, {
      rootMargin: "0px",
      loaded: function (element) {
        element.setAttribute("data-loaded", "true");
      },
    });
    lazyElements.forEach((element) => observer.triggerLoad(element));
  }

  const prevButton = element.querySelector(".c-embla-arrows__link--prev");
  const nextButton = element.querySelector(".c-embla-arrows__link--next");

  if (prevButton && nextButton) {
    prevButton.onclick = () => {
      emblaApi.scrollPrev();
    };
    nextButton.onclick = () => {
      emblaApi.scrollNext();
    };
  }
  return emblaApi;
};

export { initializeEmblaModal as emblaModal };
